<template>
  <div class="web-relevant">
    <!-- 相关推荐 start -->
    <cms-title titleChinese="置顶新闻" titleEnglish="ZhiDingXinWen"></cms-title>
    <div v-loading="stickLoading">
      <div class="releative-box">
        <div class="releative-items" v-for="(item,index) in stickList" :key="index" @click="skipNewsDetials(item.id,item.p0,item.webUrl)">
          <p class="releative-title ellipsis">{{item.title}}</p>
          <div class="releative-info ellipsis">
            <span>{{item.source}}</span>
            <span>{{item.publishDate}}</span>
          </div>
        </div>
      </div>
    </div>
    <img src="../assets/images/common/village1.png" alt="" class="relevant-ad">
    <!-- 相关推荐 end -->
    <!-- 热门评论 start -->
    <cms-title titleChinese="相关推荐" titleEnglish="XiangGuanTuiJian"></cms-title>
    <div v-loading="correlationLoading">
      <div class="comment-boxs">
        <div class="comment-items ellipsis" v-for="(item,index) in correlationList" :key="index" @click="skipNewsDetials(item.id,item.p0,item.webUrl)">{{item.title}}</div>
      </div>
    </div>
    <img src="../assets/images/common/village2.png" alt="" class="relevant-ad ad2">
    <!-- 热门评论 end -->
  </div>
</template>

<script>
  export default {
    name: "relevant-news",
    data() {
      return {
        stickList: [], //置顶新闻
        stickLoading: false, //置顶新闻加载
        correlationList: [], //相关推荐
        correlationLoading: false //相关推荐加载
      }
    },
    mounted() {
      this.getData();
    },
    methods: {
      // 获取数据
      getData() {
        this.getStick();
        this.getCorrelation();
      },

      // 获取置顶新闻 start
      getStick() {
        this.correlationLoading = true;
        let that = this;
        this.getAjax(this.$api.getarticleIndexStick, {}, function(res) {
          if (res.code == 1) {
            that.stickList = res.list;
          }
          that.correlationLoading = false;
        }, function() {
          that.correlationLoading = false;
        })
      },
      // 获取置顶新闻 end

      // 获取相关推荐 start
      getCorrelation() {
        this.stickLoading = true;
        let that = this;
        this.getAjax(this.$api.getarticleCorrelationList, {
          pageNoNum: 1,
          pageSizeNum: 5
        }, function(res) {
          if (res.code == 1) {
            that.correlationList = res.list;
          }
          that.stickLoading = false;
        }, function() {
          that.stickLoading = false;
        })
      }
      // 获取相关推荐 end
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* 相关推荐 */
  .releative-box {
    width: 100%;
    background-color: #FFFFFF;
    padding: 0 10px 10px 10px;
  }

  .releative-items {
    padding: 16px 0;
    border-bottom: 1px solid #D2D2D2;
    cursor: pointer;
  }

  .releative-items:last-child {
    border-bottom: none;
  }

  .releative-title {
    font-size: 16px;
    color: #333333;
    font-family: Source Han Sans CN Bold;
  }

  .releative-info {
    margin-top: 13px;
  }

  .releative-info span {
    font-size: 14px;
    color: #666666;
    margin-left: 25px;
  }

  .releative-info span:first-child {
    margin-left: 0;
  }

  .relevant-ad {
    width: 100%;
    height: 120px;
  }

  .relevant-ad.ad2 {
    margin-top: 39px;
  }

  /* 热门评论 */
  .comment-items {
    width: 100%;
    padding-left: 17px;
    background-image: url(../assets/images/news/circle.png);
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 6px 6px;
    margin-top: 26px;
    font-size: 18px;
    color: #333333;
    font-family: Source Han Sans CN Bold;
    cursor: pointer;
  }

  .comment-items:first-child {
    margin-top: 0;
  }

  @media screen and (max-width: 800px) {

    /* 相关推荐 */
    .releative-items {
      padding: 10px 0;
    }

    .releative-info {
      margin-top: 5px;
    }

    .releative-info span {
      margin-left: 10px;
    }

    .relevant-ad {
      width: 100%;
      height: 30vw;
    }

    /* 热门评论 */
    .comment-items {
      padding-left: 10px;
      background-size: 5px 5px;
      margin-top: 15px;
      font-size: 16px;
    }

    .relevant-ad.ad2 {
      margin-top: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RelevantNews.vue